import { createOrUpdateLabRequirementsApi } from '../api/labRequirements';

export const actions = {
    createOrUpdateLabRequirements(context, model) {
        return createOrUpdateLabRequirementsApi(model);
    },
};

export const namespaced = true;
